import React from "react";
import styled from "styled-components";
import { withTheme } from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Root = styled.section`
  width: 100%;
  ${"" /* background-color: ${props => props.theme.color6}; */}
  color: ${props => props.theme.helpColor};
  font-size: 14px;
  display: flex;
  padding: 20px 5px;
  div {
      padding-left: 5px;
  }
`;

export default withTheme(({ message, theme }) => {
  return (
    <Root>
      <FontAwesomeIcon
        icon={["fas", "star"]}
        size="1x"
        color={theme.helpColor}
      />
      <div style={{ flexGrow: 1 }}>{message}</div>
    </Root>
  );
});
